export const generateSlug = (text) => {
    if (!text) return 'inconnu';
    return text.toString().toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '').replace(/-+$/, '');
};

// Find item by slug in array — checks DB slug first, then falls back to generateSlug(name)
export const findBySlug = (items, slug) => {
    if (!slug || !items || !Array.isArray(items)) return null;
    return items.find(item =>
        (item.slug && item.slug === slug) ||
        generateSlug(item.name || item.display_group || '') === slug
    );
};

// Build URL path for course navigation
// Pass edit=true to generate admin edit URLs (/apprendre/.../edit)
// Notion level: /apprendre/{subject}/{chapter}/notion/{notion-slug}/edit
export const buildCoursePath = (subject, chapter = null, notion = null, edit = false) => {
    const parts = ['/apprendre'];
    if (subject) parts.push(subject.slug || generateSlug(subject.name));
    if (chapter) parts.push(chapter.slug || generateSlug(chapter.name));
    if (notion)  { parts.push('notion'); parts.push(notion.slug || generateSlug(notion.name)); }
    if (edit)    parts.push('edit');
    return parts.join('/');
};
